import React from 'react';
import { CalculatorIcon, ClipboardListIcon, LineChartIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const bonuses = [{
  n: '01',
  icon: CalculatorIcon,
  title: 'Calculadora de gestión de riesgo',
  text: 'Tamaño de posición, stop loss y % de riesgo por operación.'
}, {
  n: '02',
  icon: ClipboardListIcon,
  title: 'Plantilla de backtesting',
  text: 'Paso a paso para las 3 estrategias del ebook.'
}, {
  n: '03',
  icon: LineChartIcon,
  title: 'Casos reales analizados',
  text: '5 operaciones desglosadas: entrada, salida, aciertos y errores.'
}];
export function BonusSection() {
  return <Section className="bg-ink-950" data-id="element-18" data-mp="1jhkfh5cptffe">
      <Reveal data-id="element-19" data-mp="1jilqxaxn83xn">
        <span className="text-sm font-semibold uppercase tracking-widest text-brand" data-id="element-20" data-mp="1eq2a853nssom">
          Incluido sin costo extra
        </span>
        <h2 className="mt-3 font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-21" data-mp="qzes6r014moc">
          3 bonos para pasar del concepto a la práctica
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-22" data-mp="29rbi6zwbje07">
        {bonuses.map((b, i) => {
        const Icon = b.icon;
        return <Reveal key={b.n} delay={i * 0.08} data-id="element-23" data-mp="2ep38jphbes2a" data-mpi={i}>
              <div className="group h-full rounded-2xl border border-white/10 bg-ink-900 p-6 transition-colors hover:border-brand/40" data-id="element-24" data-mp="2jhmk6gwfzd4g">
                <div className="flex items-center justify-between" data-id="element-25" data-mp="2og7mqmz628w2">
                  <span className="font-display text-3xl font-extrabold text-white/10" data-id="element-26" data-mp="1quaah7bdqzsk">
                    {b.n}
                  </span>
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-soft" data-id="element-27" data-mp="1vuegg3enwc4j">
                    <Icon className="h-5 w-5 text-brand" data-id="element-28" data-mp="20tho7vm10wg7" />
                  </span>
                </div>
                <h3 className="mt-5 font-display text-base font-bold text-white" data-id="element-29" data-mp="25o52l1nbgah2">
                  <span aria-hidden="true" data-id="element-30" data-mp="3c6aef1z65cu5">🎁</span> {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-31" data-mp="3h4bxvo0ibe65">
                  {b.text}
                </p>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}